import type { SchoolId } from "@/types/navigation";

export type PhotoDim = "city" | "interior" | "map" | "floor" | "coral" | "sky" | "night";

export type SchoolCard = {
  id: SchoolId;
  abbrev: string;
  zh: string;
  en: string;
  area: string;
  blurb: string;
  photoDim: PhotoDim;
};

export const SCHOOL_CARDS: SchoolCard[] = [
  {
    id: "nus",
    abbrev: "NUS",
    zh: "新加坡国立大学",
    en: "National University of Singapore",
    area: "西南 · Kent Ridge / Clementi",
    blurb: "校区临海,周边租房选择最丰富,从HDB到高端公寓都有。",
    photoDim: "map",
  },
  {
    id: "ntu",
    abbrev: "NTU",
    zh: "南洋理工大学",
    en: "Nanyang Technological University",
    area: "西部 · Jurong / Boon Lay",
    blurb: "远离市中心,通勤是首要考量。周边新组屋多,租金温和。",
    photoDim: "interior",
  },
  {
    id: "smu",
    abbrev: "SMU",
    zh: "新加坡管理大学",
    en: "Singapore Management University",
    area: "市中心 · Bras Basah / Bugis",
    blurb: "校区在CBD边上,寸土寸金。多数同学住稍外围、地铁通勤。",
    photoDim: "city",
  },
  {
    id: "jcu",
    abbrev: "JCU",
    zh: "詹姆斯库克大学",
    en: "James Cook University",
    area: "东部 · Aljunied / Kallang / Paya Lebar",
    blurb: "校区位于新加坡东部,阿裕尼、加冷、巴耶利峇三片周边值得住。",
    photoDim: "coral",
  },
  {
    id: "curtin",
    abbrev: "科廷",
    zh: "科廷大学",
    en: "Curtin University",
    area: "西南 · One-North / Kent Ridge",
    blurb: "校区毗邻肯特岗,周边租房选择与NUS相近。",
    photoDim: "map",
  },
];
